<template>
  <div>
    <h2>Word List</h2>
    <div class="sm:tw-grid sm:tw-grid-cols-2 md:tw-grid-cols-3">
      <div v-for="w in words" :key="w.id">
        {{ w.value }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import apiCall from "@/func/net/apiCall";
import { SfSpellingTest, SfWord, SfWordCategory } from "@/types/spellingTypes";
import { defineComponent, PropType } from "vue";

export default defineComponent({
  components: {},
  props: {
    spellingRule: { type: Object as PropType<SfWordCategory | null> },
    test: { type: Object as PropType<SfSpellingTest | null> },
  },
  data() {
    return {
      words: [] as SfWord[],
    };
  },
  mounted() {
    this.loadWords();
  },
  methods: {
    async loadWords() {
      const resData = await apiCall("word", {
        cat: this.spellingRule?.id,
        all: 1,
      });
      if (resData.success) {
        this.words = resData.data.items;
      }
    },
  },
});
</script>
